import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import './MessageThread.css';

interface Message {
  id: string;
  senderId: string;
  content: string;
  timestamp: Date;
  isRead: boolean;
}

interface MessageThreadProps {
  recipientId: string;
  recipientName: string;
  rentalId: string;
}

const MessageThread: React.FC<MessageThreadProps> = ({ recipientId, recipientName, rentalId }) => {
  const { user } = useAuth();
  const [messages, setMessages] = useState<Message[]>([]);
  const [newMessage, setNewMessage] = useState('');
  const messagesEndRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (user) {
      // TODO: Replace with actual API call
      // For now using mock data
      setMessages([
        {
          id: '1',
          senderId: recipientId,
          content: 'Hi! Thanks for renting my lawnmower. Let me know if you have any questions!',
          timestamp: new Date('2024-03-20T10:00:00'),
          isRead: true
        },
        {
          id: '2',
          senderId: user.id,
          content: 'Thanks! What time would be best to pick it up on April 1st?',
          timestamp: new Date('2024-03-20T10:05:00'),
          isRead: true
        },
        {
          id: '3',
          senderId: recipientId,
          content: 'I\'m available between 9am and 6pm. Just let me know what works for you!',
          timestamp: new Date('2024-03-20T10:10:00'),
          isRead: true
        }
      ]);
    }
  }, [user, recipientId]);

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleSendMessage = (e: React.FormEvent) => {
    e.preventDefault();
    if (!newMessage.trim()) return;

    // TODO: Replace with actual API call
    const message: Message = {
      id: Math.random().toString(),
      senderId: user?.id || '',
      content: newMessage,
      timestamp: new Date(),
      isRead: false
    };

    setMessages([...messages, message]);
    setNewMessage('');
  };

  const formatTime = (date: Date) => {
    return new Intl.DateTimeFormat('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      day: '2-digit',
      month: 'short'
    }).format(date);
  };

  return (
    <div className="message-thread">
      <div className="message-header">
        <h3>Messages with {recipientName}</h3>
      </div>
      
      <div className="messages-container">
        {messages.map(message => (
          <div
            key={message.id}
            className={`message ${message.senderId === user?.id ? 'sent' : 'received'}`}
          >
            <div className="message-content">
              {message.content}
            </div>
            <div className="message-timestamp">
              {formatTime(message.timestamp)}
            </div>
          </div>
        ))}
        <div ref={messagesEndRef} />
      </div>

      <form onSubmit={handleSendMessage} className="message-input">
        <input
          type="text"
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          placeholder="Type your message..."
          maxLength={500}
        />
        <button type="submit" disabled={!newMessage.trim()}>
          Send
        </button>
      </form>
    </div>
  );
};

export default MessageThread; 